import { CuttingClientIdentification } from 'cloud-shared-lib';

export class LocalStorageManager {
  static get client(): CuttingClientIdentification {
    const LSC: string | null = localStorage.getItem('cm_client');

    if (LSC == null) {
      return undefined;
    } else {
      const clientIdent: CuttingClientIdentification = JSON.parse(LSC);

      return clientIdent;
    }
  }

  static set client(value: CuttingClientIdentification) {
    localStorage.setItem('cm_client', JSON.stringify(value));
  }

  static get regData(): number {
    const userId: string | null = localStorage.getItem('cm_reg_data');
    if (userId) {
      return Number(userId);
    } else {
      return 0;
    }
  }
  static set regData(value: number) {
    localStorage.setItem('cm_reg_data', value.toString());
  }

  static removeRegData(): void {
    localStorage.removeItem('cm_reg_data');
  }

  static removeClient(): void {
    localStorage.removeItem('cm_client');
  }

  static get currentLang(): string | null {
    return localStorage.getItem('cutting_lang');
  }
  static set currentLang(val: string) {
    localStorage.setItem('cutting_lang', val);
  }

  static get selectedProductGroupId(): number {
    return +localStorage.getItem('selected_product_group_id') || 0;
  }

  static set selectedProductGroupId(groupId: number) {
    localStorage.setItem('selected_product_group_id', groupId.toString());
  }

  static get selectedPriceListId(): number {
    return +localStorage.getItem('selected_price_list_id') | 0;
  }

  static set selectedPriceListId(selectedPriceList: number) {
    localStorage.setItem('selected_price_list_id', selectedPriceList.toString());
  }
}
